import { MapTo } from '@adobe/aem-react-editable-components';
import CardFinder, { CardFinderEditConfig } from './CardFinder';

export default MapTo('cob-corp-acquisition/components/creditonebank/card-finder')(CardFinder, CardFinderEditConfig);